import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipOptionsComponent } from './payment-sip-options.component';

import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRippleModule } from '@angular/material/core';

import { PaymentSipButtonModule } from '../payment-sip-button/payment-sip-button.module';
import { PaymentSipCardModule } from '../payment-sip-card/payment-sip-card.module';
import { PaymentSipEmandateModule } from '../payment-sip-emandate/payment-sip-emandate.module';
import { PaymentSipUpiModule } from '../payment-sip-upi/payment-sip-upi.module';
import { PaymentSipWalletModule } from '../payment-sip-wallet/payment-sip-wallet.module';
import { PaymentSipTopBankListingModule } from '../payment-sip-top-bank-listing/payment-sip-top-bank-listing.module';
import { PaymentSipSwitchPayButtonModule } from '../payment-sip-switch-pay-button/payment-sip-switch-pay-button.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { MaintenanceFeeComponent } from "../maintenance-fee/maintenance-fee.component";

@NgModule({
    declarations: [PaymentSipOptionsComponent],
    exports: [PaymentSipOptionsComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatTabsModule,
        MatRippleModule,
        PaymentSipButtonModule,
        PaymentSipCardModule,
        PaymentSipEmandateModule,
        PaymentSipUpiModule,
        PaymentSipWalletModule,
        PaymentSipTopBankListingModule,
        PaymentSipSwitchPayButtonModule,
        ModuleLoaderModule,
        MaintenanceFeeComponent
    ]
})
export class PaymentSipOptionsModule { }
